import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import { call } from '../utils';
import Type from '../Typography';

import styles from './NavBar.less';

const cx = classnames.bind(styles);

NavBar.propTypes = {
  title: PropTypes.string,
  children: PropTypes.any,
};

export default function NavBar({ children, title, ...props }) {
  return (
    <div className={cx('bar')}>
      <div className={cx('content')}>
        {title && (
          <Type face="subtext1" className={cx('title')}>
            {title}
          </Type>
        )}
        <ul className={cx('menu')}>
          {React.Children.map(children, (x) => (
            <Type
              as="li"
              face="subtext1"
              className={cx({
                active: x.props.active,
              })}
            >
              {!x || typeof x.type === 'string'
                ? x
                : React.cloneElement(x, {
                    //react-router NavLink
                    // activeClassName: styles.active,

                    //reach-router
                    getProps(o) {
                      let props = call(x.props.getProps, o);
                      return !o.isPartiallyCurrent
                        ? props
                        : {
                            ...props,
                            className: classnames((props || {}).className, styles.active),
                          };
                    },
                  })}
            </Type>
          ))}
        </ul>
      </div>
    </div>
  );
}
